import * as React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Typography, Slide } from '@mui/material'; // Import Slide here
import like from '../images/like.png';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Function to handle the transition
function TransitionUp(props) {
  return <Slide {...props} direction="down" />;
}

export default function ErrorAlert(props) {
  const {open, setOpen} = props;
  const vertical = 'top';
  const horizontal = 'center';
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Stack spacing={2} sx={{ width: '100%', zIndex: 9999, borderRadius: '16px' }}>
      <Snackbar
        open={open}
        // autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        TransitionComponent={TransitionUp} // Apply the TransitionUp function here
        PaperProps={{
          sx: {
            borderRadius: '16px',
            backgroundColor: '#22222280'
          }
        }}
      >
        <Alert severity="error" 
        sx={{
          width: '100%',
          zIndex: 9999,
          borderRadius: '16px',
          border: '1px solid #fff',
          backdropFilter: 'blur(10px)',
          backgroundColor: '#22222280', // Set your desired success background color here
          color: '#fff', // Adjust text color if needed
          '& .MuiAlert-icon': {
            color: '#fff', // Adjust icon color if needed
          },
        }}>
          <Typography sx={{ fontFamily: 'DM Sans', fontWeight: '900', fontSize: '14px', lineHeight: '26px', color: '#fff' }}>
            You are not eligible for this offer.
          </Typography>
          {/* <Typography sx={{ fontFamily: 'DM Sans', fontWeight: '600', fontSize: '14px', lineHeight: '18.2px', color: '#CCCCCC' }}>
           You are not eligible for this campaign
          </Typography> */}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
